/**
 * Where a signed-OUT worker's task link is remembered, so signing in sends them back to it
 * (SCRUM-762) — the same one deliberate exception to «no return trip» that `offer-return-intent.ts`
 * makes for a «Make offer» click, and `localStorage` for the same reason: the round trip can cross a
 * tab (a password manager, the sign-in letter opened from the mail app). Never throws.
 */
const KEY = "scb.crewReturnIntent";

export function saveCrewReturnIntent(token: string): void {
  try {
    localStorage.setItem(KEY, token);
  } catch {
    /* the link still reaches /login, it just loses the return trip */
  }
}

export function getCrewReturnIntent(): string | undefined {
  try {
    const token = localStorage.getItem(KEY);
    return token && token.length <= 64 ? token : undefined;
  } catch {
    return undefined;
  }
}

/** Clears the remembered link only if it is `token` — opening another link must not lose the one still waiting. */
export function clearCrewReturnIntent(token: string): void {
  try {
    if (localStorage.getItem(KEY) === token) localStorage.removeItem(KEY);
  } catch {
    /* nothing to clean */
  }
}
